import React from "react";
import ReactDOM from "react-dom";
import { ChainId, DAppProvider } from "@usedapp/core";
import "./assets/animated.css";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import "../node_modules/elegant-icons/style.css";
import "../node_modules/et-line/style.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.js";
import "./assets/style.scss";
import App from "./components/app";
import * as serviceWorker from "./serviceWorker";
import { ContractContextProvider } from "./context/contractsContext";

const dappConfig = {
  readOnlyChainId: ChainId.Goerli,
  readOnlyUrls: {
    // [ChainId.Goerli]: `https://eth-goerli.alchemyapi.io/v2/${REACT_APP_FIREBASE_ALCHEMY_PROJECT_ID}`,
    [ChainId.Goerli]:
      `https://goerli.infura.io/v3/${process.env.REACT_APP_FIREBASE_INFURA_PROJECT_ID}`,
  },
};

ReactDOM.render(
  <DAppProvider config={dappConfig}>
    <ContractContextProvider>
      <App />
    </ContractContextProvider>
  </DAppProvider>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
